import { useNavigate, useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import {
  useGetAllPropertyMappingsForAlignment,
  useGetAlignmentSetting,
  useUpdatePropertyMappingsForAlignment,
} from '../../../hooks/api/use-arcgis-civil3d-alignment-settings.hook';
import {
  ArcgisCivil3dAlignmentSettingApiModel,
  ArcgisCivil3dAlignmentSettingRelationship,
} from '../../../../../types/models/arcgis-civil3d-alignment-setting.model';
import { PropertyMappings } from './PropertyMappings';
import { LoadingIndicator } from '../../LoadingIndicator';
import { Civil3dFeatureTypeCategory } from '../../../../../types/constants/civil3d-feature-type';
import { WithConfiguration } from '../../../../../types/models/arcgis-civil3d-setting.model';

export const AlignmentPropertyMappings = () => {
  const navigate = useNavigate();
  const { alignmentId } = useParams<{ alignmentId: string }>();

  const [updatePropertyMappings, { error: updatePropertyMappingsError }] = useUpdatePropertyMappingsForAlignment();
  const {
    alignment,
    loading: loadingAlignment,
    error: getAlignmentError,
  } = useGetAlignmentSetting<ArcgisCivil3dAlignmentSettingApiModel & WithConfiguration>({
    alignmentId: Number(alignmentId),
    include: [ArcgisCivil3dAlignmentSettingRelationship.CONFIGURATION],
  });
  const {
    propertyMappings,
    loading: loadingPropertyMappings,
    error: propertyMappingsError,
  } = useGetAllPropertyMappingsForAlignment({
    alignmentId: Number(alignmentId),
  });
  const error = getAlignmentError || propertyMappingsError || updatePropertyMappingsError;
  if (error || propertyMappingsError) {
    return <Alert severity="error">{(error || propertyMappingsError)?.response?.data.message}</Alert>;
  }

  return loadingAlignment || loadingPropertyMappings || !alignment || !propertyMappings ? (
    <LoadingIndicator />
  ) : (
    <PropertyMappings
      settingName={alignment?.name}
      templateId={alignment?.configuration.template.id}
      featureClassId={alignment?.arcgisFeatureClass.id}
      featureTypeCategoryName={Civil3dFeatureTypeCategory.FEATURE_LINE}
      propertyMappings={propertyMappings}
      onSave={async ({ propertyMappings: propertyMappingsToSave }) => {
        await updatePropertyMappings({
          alignmentId: Number(alignmentId),
          propertyMappings: propertyMappingsToSave.filter(({ attributeId }) => Boolean(attributeId)),
        });
        navigate('..');
      }}
    ></PropertyMappings>
  );
};
